// IntegratedHomeMenuList.jsx — 통합 관리 홈 메뉴 목록 (2026-10-01, 시안대로)
//   사이드바 순서대로. 짝 달력은 짝 출퇴근 메뉴 아래 흐린 "└" 줄 — 열기 없음(그 출퇴근 메뉴 안 [달력] 탭).
//   운영자만: 배정 N명(서버 countAssignees — 퇴사자도 센다) + 편집. 그 외 사람은 열기만.
import React from 'react';
import { Link } from 'react-router-dom';
import { cn } from '../../../lib/utils';
import CompanyChip from './CompanyChip';
import { orderCompanyCodes } from '../adminlayout/integratedScope';
import { stdBlackBtn } from '../adminlayout/designStandard';

export const homeCardCls = 'min-w-0 overflow-hidden rounded-2xl border border-[var(--border)] bg-[var(--bg-card)]';
export const homeBtnCls = 'inline-flex h-[30px] items-center rounded-[9px] border border-[var(--border)] bg-[var(--bg-card)] px-2.5 text-[12px] font-bold text-[var(--text-sub)] no-underline cursor-pointer hover:bg-black/5 dark:hover:bg-white/5';

// onCreate(2026-10-15 사용자: "새 통합 메뉴를 통합 메뉴 제목 오른쪽에") — 고칠 수 있는 사람에게만 제목 줄 오른쪽 끝 '+ 새 통합 메뉴'.
//   '사이드바 순서대로'는 제목 바로 옆 작은 글씨로 옮겼다(사용자 선택 '줄 오른쪽 끝').
export default function IntegratedHomeMenuList({ rows, hqCode, isOperator, isMobile, onEdit, onCreate = null }) {
  return (
    <section className={homeCardCls}>
      <div className="flex flex-wrap items-center justify-between gap-x-3 gap-y-2 border-b border-[var(--border)] px-[18px] py-3.5">
        <div className="flex min-w-0 items-baseline gap-2">
          <h2 className="m-0 text-[15px] font-black text-[var(--text)]">통합 메뉴</h2>
          <span className="text-[12px] text-[var(--text-muted)]">사이드바 순서대로</span>
        </div>
        {onCreate && <button type="button" style={stdBlackBtn} onClick={onCreate}>+ 새 통합 메뉴</button>}
      </div>
      {rows.length === 0 && (
        <div className="px-[18px] py-10 text-center text-[13px] text-[var(--text-muted)]">통합 메뉴가 없습니다.</div>
      )}
      {rows.map((r) => (
        <div
          key={r.menu.id}
          className={cn(
            'flex items-center gap-3.5 border-b border-[var(--border)] px-[18px] py-[13px] last:border-b-0',
            r.paired && 'bg-[var(--bg-subtle)]',
            isMobile && 'flex-wrap gap-y-2',
          )}
        >
          <div className={cn('flex min-w-0 flex-1 flex-col gap-[3px]', isMobile && 'basis-full')}>
            <span className={cn('truncate text-[14px] font-black', r.paired ? 'text-[var(--text-muted)]' : 'text-[var(--text)]')}>
              {r.paired ? `└ ${r.label}` : r.label}
            </span>
            <span className="text-[12px] text-[var(--text-muted)]">{r.desc}</span>
          </div>
          <span className="flex flex-shrink-0 flex-wrap gap-1">
            {orderCompanyCodes(r.menu.company_codes, hqCode).map((c) => <CompanyChip key={c} code={c} small />)}
          </span>
          {isOperator && (
            <span className={cn('flex-shrink-0 text-[12px] font-bold text-[var(--text-sub)]', isMobile ? 'ml-auto' : 'w-16 text-right')}>
              {Number(r.menu.assignees_count) || 0}명
            </span>
          )}
          <span
            className={cn('flex flex-shrink-0 justify-end gap-1.5', !isOperator && isMobile && 'ml-auto')}
            style={isMobile ? undefined : { width: isOperator ? 120 : 56 }}
          >
            {!r.paired && <Link to={`/admin/integrated/${r.menu.id}`} className={homeBtnCls}>열기</Link>}
            {isOperator && <button type="button" className={homeBtnCls} onClick={() => onEdit(r.menu)}>편집</button>}
          </span>
        </div>
      ))}
    </section>
  );
}
